import * as React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  summaryRoot: {
    minHeight: '20px', // Custom min-height
    padding: '0px 16px', // Adjust padding if necessary
  },
  content: {
    margin: '0px', // Set margin to 0 for the content area
  },
}));

export default function SimpleAccordion(props) {
  const[open, setOpen]=React.useState((props.start_open==true)?true:false);
  const classes = useStyles();

  return (
    <div style={props.style}>
      {props.content.map(function(item){
        return(<Accordion expanded={(props.open!=undefined)?props.open:open} style={{backgroundColor:'transparent'}} onChange={(e)=>{if(props.onChange!=undefined){props.onChange();} if(props.block_propagation){e.preventDefault(); e.stopPropagation();} setOpen(!open);}}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={(props.size=='small')?{marginTop:'-8px', marginBottom:'-8px'}:undefined}/>}
            classes={(props.size=='small')?{
              content: classes.content
            }:undefined}
            style={(props.size=='small')?{minHeight:'20px'}:undefined}
            aria-controls="panel1a-content"
            id="panel1a-header"

          >
            {item.title}
          </AccordionSummary>
          <AccordionDetails style={{display:(props.open==true)?undefined:(props.open==false)?'none':(open==true)?undefined:'none', width:(props.no_padding==true)?'100%':undefined, padding:(props.no_padding==true || props.size=='small')?'0px':undefined}}>
            {item.content}
          </AccordionDetails>
        </Accordion>)
      })
      }
    </div>
  );
}
